var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-502.000000, -2574.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-bg-swap",
    transform: "translate(502.000000, 2574.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 10 0.5 10 4 6.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(2.748450, 1.100400) rotate(-30.000728) translate(-2.748450, -1.100400) ",
    x: 2.248461,
    y: 0.600411,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(1.101250, 2.752500) rotate(-59.999272) translate(-1.101250, -2.752500) ",
    x: 0.601261,
    y: 2.252511,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.65,9.4 C1,8.55 0,6.85 0,5 L0,4.5 L1,4.5 L1,5 C1,6.5 1.8,7.85 3.1,8.55 L2.65,9.4 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "6 0 9.5 0 6 3.5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(7.251350, 8.899650) rotate(-30.000728) translate(-7.251350, -8.899650) ",
    x: 6.751361,
    y: 8.399661,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    transform: "translate(8.898300, 7.247150) rotate(-59.999272) translate(-8.898300, -7.247150) ",
    x: 8.398311,
    y: 6.747161,
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.5 L9,5.5 L9,5 C9,3.5 8.2,2.15 6.9,1.45 L7.35,0.55 C9,1.45 10,3.15 10,5 L10,5.5 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBgSwap);
export default __webpack_public_path__ + "static/media/icon-bg-swap.709b4c97580b159ccf7684001febe713.svg";
export { ForwardRef as ReactComponent };